import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteCategoriaPrevisaoOrcamentaria() {
  return useMutation(
    (query: { id: string; categoriaId: string; mes?: string }) => {
      if (query.mes) {
        return http.delete(
          `/v1/previsao-orcamentaria/${query.id}/categoria/${query.categoriaId}/mes/${query.mes}`
        );
      }
      return http.delete(
        `/v1/previsao-orcamentaria/${query.id}/categoria/${query.categoriaId}`
      );
    },
    { retry: false }
  );
}

export default useDeleteCategoriaPrevisaoOrcamentaria;
